import { Button } from '@britishcouncil/react-admin';
import { Modal } from 'semantic-ui-react';
import { Link, generatePath, useLocation } from 'react-router';
import { ROUTING_PATHS } from 'const';
import { useIntParam } from 'hooks';

type Props = {
  isSaving: boolean;
  formId: string;
};

export const Footer = ({ isSaving, formId }: Props) => {
  const { speakingSessionDetails } = ROUTING_PATHS;
  const sessionId = useIntParam('sessionId');
  const location = useLocation();

  return (
    <Modal.Actions>
      <Link
        to={generatePath(speakingSessionDetails.absolutePath, { sessionId })}
        state={location.state}
        data-testid="cancel-edit-speaking-session"
      >
        <Button compact type="reset" secondary>
          Cancel
        </Button>
      </Link>

      <Button
        compact
        color="blue"
        type="submit"
        form={formId}
        disabled={isSaving}
        loading={isSaving}
        data-testid="save-speaking-session"
      >
        Save
      </Button>
    </Modal.Actions>
  );
};
